export default __webpack_public_path__ + "static/media/newsImg2.05648e34.jpg";